<template>
  <ExternalQueryList
      headline="Milestones"
      endpoint="/api/v2/project-milestones"
      :endpoint-filters="{project_id: project.id}"
      :headlines="headlines"
      :checkbox-column-width="2"
      :button-column-width="2"
      :can-destroy="() => true"
      @show="projectMilestone => edit(projectMilestone)"
  >
    <template v-slot:default="{ row: projectMilestone }">
      <td class="table__ellipsis">
        {{ projectMilestone.attributes.name }}
      </td>

      <td class="table__ellipsis">
        <span v-if="projectMilestone.attributes.date">
          {{ projectMilestone.attributes.date | date }}
        </span>

        <span v-else>
          N/A
        </span>
      </td>

      <td>
        <Avatar
            v-for="projectMilestoneManager in projectMilestone.attributes.project_milestone_managers" :key="projectMilestoneManager.user_id"
            :color="projectMilestoneManager.user_color"
        >
          {{ projectMilestoneManager.user_initials }}
        </Avatar>
      </td>

      <td>
        <span v-if="projectMilestone.attributes.completed_at" class="label label-success">
          Complete
        </span>

        <span v-else class="label label-info">
          Incomplete
        </span>
      </td>
    </template>

    <template v-slot:list-actions="{selected, load}">
      <li :class="{'disabled': !selected.length}">
        <a href="#" @click.prevent="selected.length && complete(selected, load)">
          <i class="fa fa-check"></i> Complete
        </a>
      </li>
    </template>

    <template v-slot:modals="{ load, update }">
      <CreateModal :project="project" @created="load"/>

      <EditModal :project-milestone="editing" @updated="update"/>
    </template>

    <template v-slot:headline-right>
      <a href="#create-project-milestone-modal" data-toggle="modal" class="btn btn-white btn-sm" style="margin-top: 4px;">
        <i class="fa fa-plus"></i> Create
      </a>
    </template>
  </ExternalQueryList>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import CreateModal from "../Modals/Create.vue";
import EditModal from "../Modals/Edit.vue";
import ExternalQueryList from '../../../Panels/Lists/ExternalQuery'
import Avatar from "../../../Avatar.vue";

export default {
  components: {Avatar, CreateModal, EditModal, ExternalQueryList},

  props: {
    project: {
      required: true
    }
  },

  data() {
    return {
      editing: null
    }
  },

  computed: {
    headlines() {
      return [
        {width: 7, text: 'Name'},
        {width: 4, text: 'Date'},
        {width: 6, text: 'Managers'},
        {width: 3, text: 'Status'},
      ]
    },
  },

  methods: {
    edit(projectMilestone) {
      this.editing = projectMilestone

      $("#edit-project-milestone-modal").modal("show")
    },

    complete(projectMilestones,load) {
      Promise.all(
          projectMilestones.map(projectMilestone => http.post('/api/v2/project-milestones/' + projectMilestone.id +'/complete'))
      ).then(() => {
        notify.success('The milestones were completed')

        load()
      })
    }
  }
}
</script>
